export default [
  {
    path: "/user/login",
    name: "UserLogin",
    meta: { title: "Login" },
    component: () => import("../views/user/login.vue")
  },
]